import { ICardContractPayments } from './types'

import { IconClearClose } from '@img/icons'
import { SelectDate } from '@primitive/calendar'
import { getInputButton } from '@primitive/getInputButton'
import { Flex, Modal, Input, Button, Container, Toogle } from '@ui/index'


/** Анкета создания/редактирования оплат по договору */
export const CardContractPayments = ({
    isOpen, cardMode, fieldsError, 
    txtPaymentRefund, txtPaymentNumber, txtPaymentDate, txtPaymentSum, txtPaymentPayer,
    handleBtnSave, handlerButtonCancel
}: ICardContractPayments) => {
    return <>
        <Modal isOpen={isOpen} isEsc onCancel={handlerButtonCancel} overflowY="hidden" maxWidth="350px">
            <Flex className='modal_container'>
                <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className='modal_container-header'>
                    <h4>{cardMode === 'new' ? 'Добавление платежа' : 'Редактирование платежа...'}</h4>

                    <Button variant='icon' size='md' onClick={handlerButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Container padding='6px'>
                    <Flex gap='15px' className='modal_container-content'>
                        <Flex gap='15px'>
                            <Container type='secondary' padding='4px 4px 4px 10px'>
                                <Flex gap="10px" flexDirection="row" justifyContent='space-between' alignItems="center" width='100%'>
                                    <p>Возврат средств клиенту:</p>
                                    
                                    <Toogle checked={txtPaymentRefund.value === 1} onChange={() => 
                                        txtPaymentRefund.setValue(txtPaymentRefund.value === 1 ? 0 : 1)
                                    } />
                                </Flex>
                            </Container>

                            <Flex className={!fieldsError.value.paymentNumber ? 'input_error' : 'input_error input_error-active'}>
                                <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Номер платежа из выписки <p className='pulse'></p></Flex>
                                <Input placeholder="Номер платежа из выписки" {...txtPaymentNumber}
                                    suffix={txtPaymentNumber.value && getInputButton('clear', txtPaymentNumber.reset)}
                                />
                            </Flex>

                            <Flex className={!fieldsError.value.paymentDate ? 'input_error' : 'input_error input_error-active'}>
                                <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Дата платежа из выписки <p className='pulse'></p></Flex>
                                <Input placeholder="Дата платежа из выписки" type='mask' mask='99.99.9999' {...txtPaymentDate} 
                                    suffix={
                                        <SelectDate currentDate={txtPaymentDate.value} onSelect={(date) => { txtPaymentDate.setValue(date) }}>
                                            {getInputButton('calendar')}
                                        </SelectDate>
                                    }
                                />
                            </Flex>

                            <Flex className={!fieldsError.value.paymentSum ? 'input_error' : 'input_error input_error-active'}>
                                <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Сумма платежа из выписки <p className='pulse'></p></Flex>
                                <Input placeholder="Сумма платежа из выписки" {...txtPaymentSum}
                                    suffix={txtPaymentSum.value && getInputButton('clear', txtPaymentSum.reset)}
                                />
                            </Flex>

                            <Flex className={!fieldsError.value.paymentPayer ? 'input_error' : 'input_error input_error-active'}>
                                <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Плательщик из выписки <p className='pulse'></p></Flex>
                                <Input placeholder="Плательщик из выписки" {...txtPaymentPayer}
                                    suffix={txtPaymentPayer.value && getInputButton('clear', txtPaymentPayer.reset)}
                                />
                            </Flex>
                        </Flex>
    
                        <Button width='100%' onClick={handleBtnSave}>{cardMode === 'new' ? 'Добавить платёж' : 'Изменить платёж'}</Button>
                    </Flex>
                </Container>
            </Flex>
        </Modal>
    </>
}